import AbstractListView from '@UI/Store/AbstractListView';
import type TranscriptSpeakerView from '@UI/Store/Interviews/Views/TranscriptSpeakerView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `removeSpeaker` exists solely for the merge handler, which replaces the target and drops the source
 * in the same store update (`UI/Store/Interviews/index.ts`).
 */
class TranscriptSpeakersListView extends AbstractListView<TranscriptSpeakerView> {
	readonly interviewId: number;

	constructor(list: readonly TranscriptSpeakerView[], interviewId: number) {
		super(list, 'TranscriptSpeakersListView');

		this.interviewId = interviewId;

		Object.freeze(this);
	}

	replaceSpeaker(speaker: TranscriptSpeakerView): TranscriptSpeakersListView {
		return new TranscriptSpeakersListView(
			this.list.map((entry) => (entry.id === speaker.id ? speaker : entry)),
			this.interviewId,
		);
	}

	removeSpeaker(speakerId: number): TranscriptSpeakersListView {
		return new TranscriptSpeakersListView(
			this.list.filter((entry) => entry.id !== speakerId),
			this.interviewId,
		);
	}
}

export default TranscriptSpeakersListView;
